import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/home/home';
import Products from './components/products/products';
import Statistics from './components/statistic/statistic';
import Certificate from './components/certificate/certificate';
import Footer from './components/footer/footer';
import Order1 from './components/order1/order1';
import Order2 from './components/order2/order2';
import Order3 from './components/order3/order3';
import About from './components/about/about';
import Services from './components/services/services';
import Comone from './components/comone/comone';
import ComTwo from './components/comtwo/comtwo';
import ComThree from './components/comthree/comtree';
import ComFour from './components/comfour/comfour';
import OurCompany from './components/ourCompany/ourCompany';
import Brands from './components/brands/brands';
import LearnMore from './components/ourCompany/learnMore';
import Solutions from './components/solutions/solutions';
import Knowledgehub from './components/comfour/knowledgehub';
import SEO from './components/SEO';
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from './components/scrollToTop';
import NewSolution from './components/solutions/newSolution';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/ourCompany" element={<LearnMore />} />
        <Route path="/knowledgehub" element={<Knowledgehub />} />
        <Route path="/solutions" element={<Solutions />} />
      </Routes>
    </BrowserRouter>
  );
}

function HomePage() {
  return (
    <div>
      <div id="home-section">
        <Home />
      </div>
      <div id="">
        <Comone />
      </div>
      <div id="product-section">
        <ComTwo />
      </div>
      <div id="company-section">
        <OurCompany />
      </div>
      <div id="solutions-section">
        <NewSolution />
      </div>
      <div id="">
        <ComThree />
      </div >
      <div id="brand-section">
      <Brands />
      </div>
      <div id="the hub-section">
        <ComFour />
      </div>
      
      
      <div id="contact us-section">
        <Order3 />
      </div>
      <Footer />
    <SEO/>
    </div>
  );
}

export default App;
